interface MetaDataState {
  combiningStrongAlcoholAllowed: boolean;
  currency: string;
  hasError: boolean;
  hideQuickPaymentButton: boolean;
  locale: string;
  mySurpriseUrl: string;
  paymentMethods: string[];
  showShoppingAward: boolean;
  specialDiscountPeriod: boolean;
}

const initialMetaDataState: MetaDataState = {
  combiningStrongAlcoholAllowed: true,
  currency: '',
  hasError: false,
  hideQuickPaymentButton: false,
  locale: 'nl-NL',
  mySurpriseUrl: '/mysurprise',
  paymentMethods: [],
  showShoppingAward: false,
  specialDiscountPeriod: false,
};

export type { MetaDataState };
export default initialMetaDataState;
